import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useState } from "react";
import ScrollToTop from "./components/ScrollToTop";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Services } from "./pages/Services";
import { Courses } from "./pages/Courses";
import { Contact } from "./pages/Contact";
import { Blogs } from "./pages/Blogs";
import { Events } from "./pages/Events";
import { Notices } from "./pages/Notice";
import { NotFound } from "./components/404";
import { AdminDashboard } from "./admin/Dashboard";
import ProtectedRoute from "./utils/ProtectedRoute";
import LoginPage from "./components/AdminLogin";
import CrmPortal from "./admin/crm/CrmPortal";
import NavBar from "./layouts/NavBar";
import Footer from "./layouts/Footer";

const AppContent = ({ isAuthenticated, login, logout }) => {
  const location = useLocation();
  const validNavPaths = [
    "/",
    "/about",
    "/services",
    "/courses",
    "/contact",
    "/blogs",
    "/events",
    "/notice",
  ];

  const hideLayout = !validNavPaths.includes(location.pathname);

  return (
    <>
      {!hideLayout && <NavBar isAuthenticated={isAuthenticated} />}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/events" element={<Events />} />
        <Route path="/notice" element={<Notices />} />

        <Route
          path="/admin"
          element={
            <LoginPage login={login} isAuthenticated={isAuthenticated} />
          }
        />

        {/* Protected Route */}
        <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
          <Route
            path="/dashboard"
            element={<AdminDashboard logout={logout} />}
          />
        </Route>

        <Route path="/crm" element={<CrmPortal />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
      {!hideLayout && <Footer />}
    </>
  );
};

export const AppRoutes = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return !!localStorage.getItem("token"); // ✅ check if JWT exists
  });

  const login = (token) => {
    setIsAuthenticated(true);
    localStorage.setItem("token", token); // ✅ save JWT
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("token"); // ✅ remove JWT
  };

  return (
    <Router>
      <AppContent
        isAuthenticated={isAuthenticated}
        login={login}
        logout={logout}
      />
    </Router>
  );
};
